// #region imports

// --- HS Code
import { RegistrationCodeValidationResults } from "./registration-code-validation-results";

// #end region

export interface RegistrationCodeValidationResultModel {
  validationResult: RegistrationCodeValidationResults;
  registrationCode: string | null | undefined;
  participantId: string | null | undefined;
}
